module.exports = __webpack_public_path__ + "static/0047-220b83e690e4207ac192be36dc1c4b35.png";